import { render, staticRenderFns } from "./default.vue?vue&type=template&id=01e59592&scoped=true"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"
import style0 from "./default.vue?vue&type=style&index=0&id=01e59592&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e59592",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Notification: require('/builds/gb-developers/geekbrains-client/components/global/Notification/Notification.vue').default})
